import mutationsTypes from '@/store/mutationTypes'

const Mutations = {}

export default Mutations
